import { render, staticRenderFns } from "./analyticsPlatform.vue?vue&type=template&id=69ef83c8&scoped=true&"
import script from "./analyticsPlatform.vue?vue&type=script&lang=js&"
export * from "./analyticsPlatform.vue?vue&type=script&lang=js&"
import style0 from "./analyticsPlatform.vue?vue&type=style&index=0&id=69ef83c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ef83c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
